import api from './api';

export interface InternalTask {
  id: number;
  patient_id: number;
  patient_name: string | null;
  patient_hm_id: string | null;
  meeting_id: number | null;
  task_type_id: number | null;
  task_type_name: string | null;
  assign_to: number[] | null;
  assignee_names: string[] | null;
  priority: string;
  status: string;
  description: string | null;
  created_by: number | null;
  created_by_name: string | null;
  tenant_id: number;
  created_at: string;
  updated_at: string;
}

export interface InternalTaskCreate {
  patient_id: number;
  task_type_id?: number | null;
  meeting_id?: number | null;
  assign_to?: number[];
  priority: string;
  status?: string;
  description?: string | null;
}

export interface InternalTaskUpdate {
  task_type_id?: number | null;
  meeting_id?: number | null;
  assign_to?: number[];
  priority?: string;
  status?: string;
  description?: string | null;
}

export interface InternalTaskFilters {
  patient_id?: number;
  status_filter?: string;
  priority?: string;
  task_type_id?: number;
  assignee_id?: number;
}

export interface InternalTaskHistoryItem {
  id: number;
  date: string;
  user_id: number | null;
  user_name: string | null;
  action: string;
  type: string | null;
  notes: string;
}

export const INTERNAL_TASK_STATUSES = ['New', 'In Progress', 'Waiting for Response', 'Finish', 'Done'];
export const INTERNAL_TASK_OPEN_STATUSES = ['New', 'In Progress', 'Waiting for Response', 'Finish'];
export const INTERNAL_TASK_PRIORITIES = ['Urgent', 'High', 'Medium', 'Low'];

export const internalTaskService = {
  async getInternalTasks(filters: InternalTaskFilters = {}): Promise<InternalTask[]> {
    const response = await api.get('/internal-tasks/', { params: filters });
    return response.data;
  },

  async create(data: InternalTaskCreate): Promise<InternalTask> {
    const response = await api.post('/internal-tasks/', data);
    return response.data;
  },

  async update(id: number, data: InternalTaskUpdate): Promise<InternalTask> {
    const response = await api.put(`/internal-tasks/${id}`, data);
    return response.data;
  },

  async remove(id: number): Promise<void> {
    await api.delete(`/internal-tasks/${id}`);
  },

  async getHistory(id: number): Promise<InternalTaskHistoryItem[]> {
    const response = await api.get(`/internal-tasks/${id}/history`);
    return response.data;
  },

  // Count of tasks needing the current user's attention (drives the sidebar badge).
  async getNeedsActionCount(): Promise<number> {
    const response = await api.get('/internal-tasks/needs-action-count');
    return response.data.count;
  },
};

export default internalTaskService;
